import { store } from '@store';

import { useDataLoading } from '@utils/hooks/useDataLoading';

export function useAuthUserCertificates() {
    const { authUserCertificates } = store;

    useDataLoading(async () => {
        await authUserCertificates.updateCryptoProInfo();
        await authUserCertificates.setContainerCertificates();
    }, []);

    return {
        certificateOptions: authUserCertificates.certificateOptions,
        signContent: authUserCertificates.signContent,
    };
}
